import { PlanType } from "../models/plans.model";
import { RootState } from "../stores/app-store";
export const loggedInUserroleId = (state: RootState) => state.userRoleId
export const conversations = (state: RootState) => state.Conversations
export const secureChatConversations = (state: RootState) => state.SecureChatConversations
export const secureChatNewConversationsCount = (state: RootState) => state.SecureChatConversations.filter(x => (x.UnReadCount) > 0).length
export const falkonWebSocket = (state: RootState) => state.FalkonWebSocket
export const webSocketConnection = (state: RootState) => state.WebSocketConnection
export const dataLoading = (state: RootState) => state.DataLoading
export const newConversationsCount = (state: RootState) => state.Conversations.filter(x => (!!x.GroupChat?.ID ? x.GroupChat?.UnReadCount : x.UnReadCount) > 0).length
export const profile = (state: RootState) => state.Profile
export const isMobileDevice = (state: RootState) => state.IsMobileDevice
export const isTeamsApp = (state: RootState) => state.IsTeamsApp
export const normalTextingUsage = (state: RootState) => state.PlanMetrics.NormalTextingUsage
export const groupTextingUsage = (state: RootState) => state.PlanMetrics.GroupCreditsUsage
export const phoneNumbers = (state: RootState) => state.PhoneNumbers
export const usersAlertNotification = (state: RootState) => state.UserAlertNotifications
export const showingAlert = (state: RootState) => state.ShowingAlertsCount > 0
export const planMetrics = (state: RootState) => state.PlanMetrics
export const deviceWidth = (state: RootState) => state.DeviceWidth
export const deviceHeight = (state: RootState) => state.DeviceHeight
export const alertNotification = (state: RootState) => state.AlertNotifications
export const loadingAlertNotifications = (state: RootState) => state.LoadingAlertsNotications
export const rulesKeywords = (state: RootState) => state.RulesKeywords
export const globalRules = (state: RootState) => state.GlobalRules
export const templates = (state: RootState) => state.Templates
export const organizations = (state: RootState) => state.Organizations
export const plans = (state: RootState) => state.Plans
export const features = (state: RootState) => state.Features
export const loadingRules = (state: RootState) => state.LoadingAutomationGlobalRules
export const allKeywords = (state: RootState) => state.AllKeywords
export const privateRules = (state: RootState) => state.PrivateRules
export const groups = (state: RootState) => state.Groups
export const IsMassGroupsDeletionInProgress = (state: RootState) => state.LoadedGroups
export const contacts = (state: RootState) => state.Contacts
export const customAttributeFields = (state: RootState) => state.CustomAttributeDefinitions ?? []
export const getUnSubscribedContacts = (state: RootState) => state.GetUnSubscribedContacts
export const getBlockedContacts = (state: RootState) => state.GetBlockedContacts
export const groupContactsDeletionData = (state: RootState) => state.GroupContactsDeletionData
export const settings = (state: RootState) => state.Settings.Settings
export const isMassDeletionInProgress = (state: RootState) => state.IsMassContactsDeletionInProgress
export const isMassUsersDeletionInProgress = (state: RootState) => state.IsMassUsersDeletionInProgress
export const users = (state: RootState) => state.Users
export const allUsers = (state: RootState) => state.AllUsers
export const typingData = (state: RootState) => state.TypingData
export const history = (state: RootState) => state.History
export const chatSummaryHistory = (state: RootState) => state.ChatSummaryHistory
export const ContactTypes = (state: RootState) => state.ContactTypes
export const showSideMenu = (state: RootState) => state.ShowSideMenu
export const newMessageRecived = (state: RootState) => state.NewMessageRecived
export const secureFileLinks = (state: RootState) => state.SecureFileLinks
export const kafka = (state: RootState) => state.Kafka
export const providers = (state: RootState) => state.Providers
export const oadingProviders = (state: RootState) => state.LoadingProviders
export const planHistory = (state: RootState) => state.PlanHistory
export const roles = (state: RootState) => state.Roles
export const reports = (state: RootState) => state.Reports
export const allGlobalRules = (state: RootState) => state.AllGlobalRules
export const settingsObj = (state: RootState) => state.Settings
export const addons = (state: RootState) => state.Plans.filter(x => x.Type === PlanType.ADD_ON)
export const headerCount = (state: RootState) => state.HeaderCount
export const refreshHandler = (state: RootState) => state.RefreshHandler;
export const backHandler = (state: RootState) => state.BackHandler;
export const headerTitle = (state: RootState) => state.HeaderTitle;
export const toasts = (state: RootState) => state.Toasts;
export const notificationsEnabled = (state: RootState) => state.Settings.NotificationsEnabled;
export const organizationLoginType = (state: RootState) => state.OrganizationLoginType;
export const secureDocs = (state: RootState) => state.SecureDocs

export const loadingConversations = (state: RootState) => state.LoadingConversations;
export const loadingSecureChatConversations = (state: RootState) => state.LoadingSecureChatConversations;
export const loadingHistory = (state: RootState) => state.LoadingHistory;
export const loadingContacts = (state: RootState) => state.LoadingContacts;
export const loadingContactTypes = (state: RootState) => state.LoadingContactTypes;
export const loadingUsers = (state: RootState) => state.LoadingUsers;
export const loadingGroups = (state: RootState) => state.LoadingGroups;
export const loadingOrganizations = (state: RootState) => state.LoadingOrganizations;
export const loadingSettings = (state: RootState) => state.LoadingSettings;
export const loadingProfile = (state: RootState) => state.LoadingProfile;
export const loadingFeatures = (state: RootState) => state.LoadingFeatures;
export const loadingRoles = (state: RootState) => state.LoadingRoles;
export const loadingPhoneNumbers = (state: RootState) => state.LoadingPhoneNumbers;
export const loadingPlans = (state: RootState) => state.LoadingPlans;
export const loadingProviders = (state: RootState) => state.LoadingProviders;
export const loadingOrganizationDetails = (state: RootState) => state.LoadingOrganizationDetails;
export const loadingAlertsNotications = (state: RootState) => state.LoadingAlertsNotications;
export const loadingAutoAlertKeywords = (state: RootState) => state.LoadingAutoAlertKeywords;
export const loadingTemplates = (state: RootState) => state.LoadingTemplates;
export const loadingAutomationPrivateRules = (state: RootState) => state.LoadingAutomationPrivateRules;
export const loadingAutomationGlobalRules = (state: RootState) => state.LoadingAutomationGlobalRules;
export const loadingReports = (state: RootState) => state.LoadingReports;
export const loadingKafka = (state: RootState) => state.LoadingKafka;
export const secureFiles = (state: RootState) => state.SecureFiles;
export const faceAuthenticatonFiles = (state: RootState) => state.FaceAuthenticationFiles;
export const loadingFaceAuthenticationFiles = (state: RootState) => state.LoadingAutomationPrivateRules;
export const loadingSecureFiles = (state: RootState) => state.LoadingSecureFiles;
export const loadingSecureFileLinks = (state: RootState) => state.LoadingSecureFileLinks;
// export const allContacts = (state: RootState) => state.AllContacts;
export const scheduleMessages = (state: RootState) => state.ScheduleMessages;
export const loadingScheduleMessages = (state: RootState) => state.LoadingscheduleMessages;
export const loadingSecureDocs = (state: RootState) => state.LoadingSecureDocs;

export const loadedConversations = (state: RootState) => state.LoadedConversations;
export const loadedHistory = (state: RootState) => state.LoadedHistory;
export const loadedContacts = (state: RootState) => state.LoadedContacts;
export const loadedContactTypes = (state: RootState) => state.LoadedContactTypes;
export const loadedUsers = (state: RootState) => state.LoadedUsers;
export const loadedGroups = (state: RootState) => state.LoadedGroups;
export const loadedOrganizations = (state: RootState) => state.LoadedOrganizations;
export const loadedSettings = (state: RootState) => state.LoadedSettings;
export const loadedProfile = (state: RootState) => state.LoadedProfile;
export const loadedFeatures = (state: RootState) => state.LoadedFeatures;
export const loadedRoles = (state: RootState) => state.LoadedRoles;
export const loadedPhoneNumbers = (state: RootState) => state.LoadedPhoneNumbers;
export const loadedPlans = (state: RootState) => state.LoadedPlans;
export const loadedProviders = (state: RootState) => state.LoadedProviders;
export const loadedOrganizationDetails = (state: RootState) => state.LoadedOrganizationDetails;
export const loadedSecureDocs = (state: RootState) => state.LoadedSecureDocs;

export const isMassContactsDeletionInProgress = (state: RootState) => state.IsMassContactsDeletionInProgress;
export const isMassGroupsDeletionInProgress = (state: RootState) => state.IsMassGroupsDeletionInProgress;
export const handleMassContactsActionEvent = (state: RootState) => state.HandleMassContactsActionEvent;
export const handleMassGroupsActionEvent = (state: RootState) => state.HandleMassGroupsActionEvent;
export const IsMessageLogDownloadReportMsg = (state: RootState) => state.IsMessageLogDownloadReportMsg;
export const ExportMessageLogs = (state: RootState) => state.ExportMessageLogs;
export const SecureChatExportMessageLogs = (state: RootState) => state.SecureChatExportMessageLogs;
export const WebNotificationText = (state: RootState) => state.WebNotificationText;
export const OrganizationName = (state: RootState) => state.OrganizationName;
export const SelectedPhonenumberOrganizations = (state: RootState) => state.PhonenumberSelectedOrgIDs;
export const IsActivityFeedNotificationEnabled = (state: RootState) => state.ActivityFeedNotificationStatus;
export const IsNotificationEnabled = (state: RootState) => state.NotificationStatus;
export const IsWebexNotificationEnabled = (state: RootState) => state.WebexNotificationStatus;
export const IsFalkonSignNotificationEnabled = (state: RootState) => state.IsFalkonSignNotification;
export const SelectedUsersOrganizations = (state: RootState) => state.UsersSelectedOrgIDs;
export const OrganizationsphoneNumbers = (state: RootState) => state.OrganizationsphoneNumbers;
export const OrganizationsUsers = (state: RootState) => state.OrganizationsUsers;
export const headerSelectedCount = (state: RootState) => state.HeaderSelectedCount;
export const businessHoursStatus = (state: RootState) => state.BusinessHoursStatus;
export const assignToUserDetails = (state: RootState) => state.AssignToUser;
export const contactStatusHistory = (state: RootState) => state.ContactStatusHistory;
export const lowCreditSettings = (state: RootState) => state.LowCreditSettings;
export const IscontactsSyncing = (state: RootState) => state.IscontactsSyncing;
export const IsUsersSyncing = (state: RootState) => state.IsUsersSyncing;
export const IsGroupContactsSyncing = (state: RootState) => state.IsGroupContactsSyncing;
export const BulkImportSyncDetails = (state: RootState) => state.BulkImportSyncDetails;
export const IsSignalRConnected = (state: RootState) => state.isSignalRConnected;
export const isDarkMode = (state: RootState) => state.isDarkMode;
export const TrainChatHistoryStatus = (state: RootState) => state.TrainChatHistoryStatus;
export const AiTrainedFiles = (state: RootState) => state.AiTrainedFiles;
export const AiTrainedUrls = (state: RootState) => state.AiTrainedUrls;
export const phonenumbergroups = (state: RootState) => state.PhoneNumberGroups;
export const OrganzationPhoneNumberGroups = (state: RootState) => state.OrganzationPhoneNumberGroups;
export const SelectedPhoneGroupOrganizations = (state: RootState) => state.PhoneGroupsSelectedOrgIDs;
export const newPlans = (state: RootState) => state.newPlans;
export const loadingNewPlans = (state: RootState) => state.LoadingNewPlans;
export const newOrganizations = (state: RootState) => state.NewOrganizations;
export const isNewOrgFlow = (state: RootState) => state.IsNewOrgFlow;
export const userPlanTracker = (state: RootState) => state.UserPlanTracker;
export const orgPlanTracker = (state: RootState) => state.OrgPlanTracker;
export const loadedNewPlans = (state: RootState) => state.LoadedNewPlans;
export const optInCollectedMessage = (state: RootState) => state.OptInCollectedMessage;
export const IsScheduleMessageImporting = (state: RootState) => state.IsScheduleMessageImporting;


export const SecureChatScheduleMessages = (state: RootState) => state.SecureChatScheduleMessages;
export const ConversationsAssignStatus = (state: RootState) => state.ConversationsAssignStatus;
export const NewSubscriptionOrganizationsphoneNumbers = (state: RootState) => state.NewSubscriptionOrganizationsphoneNumbers;
export const NewSubscriptionPhonenumberSelectedOrgIDs = (state: RootState) => state.NewSubscriptionPhonenumberSelectedOrgIDs;
export const NewSubscriptionSelectedUsersOrgIds = (state: RootState) => state.NewSubscriptionSelectedUsersOrgIds;
export const NewSubscriptionOrganizationsUsers = (state: RootState) => state.NewSubscriptionOrganizationsUsers;
export const WebForms = (state: RootState) => state.WebForms;
export const FalkonEsignTemplates = (state: RootState) => state.FalkonEsignTemplates;
export const ArchiveConfigurableDaysSetting = (state: RootState) => state.ArchiveConfigurableDaysSetting;
